function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback } from 'react';
import { Checkbox, MenuList, MenuItem, Popper, Paper, ClickAwayListener, Grow, Button, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { pushTableCols, pushTableHeadCols } from '../../slices/customQueryBodySlice';
import startCase from 'lodash/startCase';
import camelCase from 'lodash/camelCase';
import exportReorder from '../../assets/img/Export-Reorder.svg';
import exportReorderActive from '../../assets/img/Export-Reorder-active.svg';
import styled from 'styled-components';
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex'
  },
  paper: {
    marginRight: theme.spacing(0)
  },
  buttonRoot: {
    marginTop: 11,
    paddingLeft: 11
  }
}));
export const StyledLabel = styled.span`
  color: ${props => props.isSelected ? '#005099' : '#212121'};
  text-transform: none;
  line-height: 24px;
  font-size: 13px;
  opacity: 0.87;
  font-family: 'OpenSans-Light';
`;
export const StyledMenuItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    width: 100%;
    background-color: ${props => props.index === props.lastIndex && '#c6c7c8'};
  }
  &:hover {
    background-color: ${props => props.index === props.lastIndex && '#c6c7c8 !important'};
  }
`;
export const StyledSpanItem = styled.span`
  color: rgba(0, 0, 0, 0.85);
  font-family: 'OpenSans-Regular';
  font-size: 14px;
  letter-spacing: 0;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 137px;
`;

const DropDownMenu = props => {
  let {
    menuItems = []
  } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [lastIndex, setLastIndex] = React.useState('');
  const handleToggle = useCallback(() => {
    setOpen(prevOpen => !prevOpen);
  }, [open]);
  const handleClose = useCallback(event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  }, [open]);
  const handleListKeyDown = useCallback(event => {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }, [open]); // return focus to the button when we transitioned from !open -> open

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);
  const onCheckBoxClick = useCallback(name => {
    let cloneCols = JSON.parse(JSON.stringify(menuItems));

    for (let col of cloneCols) {
      if (name === col.dataKey) {
        col.hidden = !col.hidden;
      }
    }

    let columnsData = cloneCols.filter(cols => {
      if (cols.hidden == false) {
        return cloneCols;
      }
    });

    if (columnsData && columnsData.length === 0) {
      setLastIndex(cloneCols.findIndex(cloneCols => cloneCols.accessor == name));
    } else {
      setLastIndex('');
      dispatch(pushTableCols(cloneCols));
      dispatch(pushTableHeadCols(columnsData));
    }
  }, [menuItems]);
  let src = open ? exportReorderActive : exportReorder;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: "Column Configuration"
  }, /*#__PURE__*/React.createElement(Button, {
    className: classes.buttonRoot,
    ref: anchorRef,
    "aria-controls": open ? 'menu-list-grow' : '',
    "aria-haspopup": "true",
    startIcon: /*#__PURE__*/React.createElement("img", {
      alt: "columnIcon",
      src: src
    }),
    onClick: handleToggle
  })), /*#__PURE__*/React.createElement(Popper, {
    open: open,
    anchorEl: anchorRef.current,
    transition: true,
    disablePortal: true,
    className: "z-999 dropdown-menu-popper",
    placement: "bottom-end"
  }, ({
    TransitionProps,
    placement
  }) => /*#__PURE__*/React.createElement(Grow, _extends({}, TransitionProps, {
    style: {
      transformOrigin: placement === 'bottom' ? 'center top' : 'right top'
    }
  }), /*#__PURE__*/React.createElement(Paper, {
    className: classes.paper
  }, /*#__PURE__*/React.createElement(ClickAwayListener, {
    onClickAway: handleClose
  }, /*#__PURE__*/React.createElement(MenuList, {
    autoFocusItem: open,
    id: "menu-list-grow",
    onKeyDown: handleListKeyDown,
    className: "dropdown-menulist"
  }, menuItems.map((col, index) => {
    return /*#__PURE__*/React.createElement("div", {
      className: "disp-flex",
      key: index
    }, /*#__PURE__*/React.createElement(StyledMenuItem, {
      index: index,
      lastIndex: lastIndex,
      onClick: () => onCheckBoxClick(col.dataKey)
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: !col.hidden,
      name: col.dataKey,
      id: `${col.name}${index}`,
      color: "primary"
    }), /*#__PURE__*/React.createElement(StyledSpanItem, {
      title: col.label
    }, startCase(camelCase(col.label)))));
  })))))));
};

export default /*#__PURE__*/React.memo(DropDownMenu);